import React from 'react'

export interface IBtnProps {
  btnName: string
  onClickHandler?: any
  type?: 'primary' | 'secondary'
  btnType?: 'button' | 'submit'
  disabled?: boolean
  length?: string
}

const Button = ({ btnName, onClickHandler, btnType = 'button', disabled, length, type }: IBtnProps) => {
  return (
    <button
      type={btnType}
      onClick={onClickHandler}
      disabled={disabled}
      className={`my-2 min-h-[2rem] w-full rounded px-3 py-2 text-sm font-medium lg:text-base ${
        disabled && btnName !== 'Back'
          ? 'rounded border-2 border-gray-400 bg-gray-400 py-12 text-black'
          : btnName === 'Back' || (btnName === 'Close' && btnType !== 'submit')
          ? 'rounded border-2 border-gray-200 bg-white py-12 text-gray-800'
          : type === 'secondary'
          ? 'rounded border-2 border-green-800 bg-green-800 py-12 text-white'
          : 'rounded border-2 border-blue-700 bg-blue-700 py-12 text-white'
      } ${length} ${disabled ? 'hover:cursor-not-allowed' : 'hover:cursor-pointer'}`}
    >
      {btnName}
    </button>
  )
}

export default Button
